
export const GET_JOBSCHEDULER = "GET_JOBSCHEDULER"
export const POST_JOBSCHEDULER = "POST_JOBSCHEDULER"
export const PUT_JOBSCHEDULER = "PUT_JOBSCHEDULER"
 
